export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20cinematic%20background%20with%20flowing%20gradient%20waves%20in%20deep%20coral%20red%20and%20warm%20amber%20tones%2C%20soft%20bokeh%20light%20particles%2C%20modern%20entertainment%20platform%20aesthetic%2C%20smooth%20curves%20and%20geometric%20overlays%2C%20dark%20moody%20atmosphere%20with%20vibrant%20color%20accents%2C%20professional%20streaming%20platform%20visual%20style%2C%20no%20text%20or%20lettering&width=1600&height=900&seq=hero-bg-91cg&orientation=landscape"
          alt="91吃瓜平台背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-sm font-medium mb-4 whitespace-nowrap border border-accent-500/30">
              全网热门吃瓜视频平台
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-4">
              91吃瓜<span className="block md:inline"> — 最新最全吃瓜视频在线观看</span>
            </h1>

            <p className="text-lg md:text-xl text-white/70 leading-relaxed max-w-2xl lg:max-w-none mb-2">
              汇聚海量高清吃瓜视频资源，涵盖娱乐八卦、社会热点、网红动态等热门内容，
              每日更新最新视频，支持流畅在线播放，随时随地畅享精彩吃瓜时刻。
            </p>
            <p className="text-base text-white/60 leading-relaxed max-w-2xl lg:max-w-none mb-6">
              平台以快速聚合、高清画质和清爽无广告的观看体验为核心，
              当前热门主题聚焦娱乐圈最新爆料、网络热门事件追踪及深度话题解读。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start mb-8">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-video-line text-accent-400 text-lg"></i>
                <span>每日更新 2000+ 视频</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-eye-line text-accent-400 text-lg"></i>
                <span>千万级日活跃观众</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <i className="ri-shield-check-line text-accent-400 text-lg"></i>
                <span>安全无广告干扰</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-xl"></i>
                立即观看热门
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-base hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-xl"></i>
                探索热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20digital%20illustration%20of%20a%20modern%20streaming%20platform%20interface%2C%20floating%20video%20thumbnails%20with%20play%20buttons%20in%20coral%20red%20and%20warm%20amber%20tones%2C%20trending%20topic%20tags%20floating%20organically%2C%20dark%20cinematic%20gradient%20background%2C%20clean%20geometric%20shapes%2C%20modern%20editorial%20design%20language%2C%20no%20recognizable%20faces%20or%20text&width=800&height=600&seq=hero-visual-91cg&orientation=landscape"
                alt="91吃瓜视频平台主视觉"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}